import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { IconButton } from 'components';

function LogoLink({ className = '' }) {
  return (
    <div>
      <NavLink to="/">
        <IconButton className={className} iconName="bell" />
      </NavLink>
    </div>
  );
}

LogoLink.propTypes = {
  className: PropTypes.string,
};

export default LogoLink;
